export enum PdfexportType {
  COLORS = 'Colors',
  TRIMS = 'Trims',
  FEATURES = 'Features',
  CO2 = 'CO2',
  DIMENSIONS = 'Dimensions'
}
